import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const baseQuery = fetchBaseQuery({
    baseUrl: process.env.REACT_APP_EMAIL_IDENTITY_API_URL,
    prepareHeaders: (headers) => {
        const user = localStorage.getItem('user');
        if (user) {
            try {
                const userToken = JSON.parse(user).token;
                headers.set('authorization', `Bearer ${userToken}`);
                headers.set('Content-Type', 'application/json');
            } catch (e) {
                console.error('Error parsing user token:', e);
            }
        }
        return headers;
    },
    credentials: "omit"
});

export const logsApi = createApi({
    reducerPath: "logsApi",
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getSentCampaignLogs: builder.query({
            query: (params) => {
                const searchParams = new URLSearchParams();
                searchParams.set('tenancyId', params.tenancyId);
                if (params.userId) searchParams.set('userId', params.userId);
                if (params.campaignId) searchParams.set('campaignId', params.campaignId);
                if (params.dateFrom) searchParams.set('dateFrom', params.dateFrom);
                if (params.dateTo) searchParams.set('dateTo', params.dateTo);
                if (params.dateFailed !== undefined && params.dateFailed !== '') searchParams.set('dateFailed', params.dateFailed);
                searchParams.set('page', params.page || 0);
                searchParams.set('pageSize', params.pageSize || 50);
                return `api/logs/sent-campaigns?${searchParams.toString()}`;
            }
        }),
        getSentUniversityCourseLogs: builder.query({
            query: (params) => {
                const searchParams = new URLSearchParams();
                searchParams.set('tenancyId', params.tenancyId);
                if (params.userId) searchParams.set('userId', params.userId);
                if (params.universityCourseName) searchParams.set('universityCourseName', params.universityCourseName);
                if (params.dateFrom) searchParams.set('dateFrom', params.dateFrom);
                if (params.dateTo) searchParams.set('dateTo', params.dateTo);
                if (params.dateCompleted !== undefined && params.dateCompleted !== '') searchParams.set('dateCompleted', params.dateCompleted);
                searchParams.set('page', params.page || 0);
                searchParams.set('pageSize', params.pageSize || 50);
                return `api/logs/sent-university-courses?${searchParams.toString()}`;
            }
        }),
        getCourseAuditLogs: builder.query({
            query: (params) => {
                const searchParams = new URLSearchParams();
                searchParams.set('tenancyId', params.tenancyId);
                if (params.email) searchParams.set('email', params.email);
                if (params.dateFrom) searchParams.set('dateFrom', params.dateFrom);
                if (params.dateTo) searchParams.set('dateTo', params.dateTo);
                if (params.messageType) searchParams.set('messageType', params.messageType);
                if (params.success !== undefined && params.success !== '') searchParams.set('success', params.success);
                searchParams.set('pageSize', params.pageSize || 50);
                if (params.lastKey) searchParams.set('lastKey', params.lastKey);
                return `api/logs/course-audit?${searchParams.toString()}`;
            }
        }),
        getSimAuditLogs: builder.query({
            query: (params) => {
                const searchParams = new URLSearchParams();
                searchParams.set('tenancyId', params.tenancyId);
                if (params.email) searchParams.set('email', params.email);
                if (params.dateFrom) searchParams.set('dateFrom', params.dateFrom);
                if (params.dateTo) searchParams.set('dateTo', params.dateTo);
                if (params.success !== undefined && params.success !== '') searchParams.set('success', params.success);
                searchParams.set('pageSize', params.pageSize || 50);
                if (params.lastKey) searchParams.set('lastKey', params.lastKey);
                return `api/logs/sim-audit?${searchParams.toString()}`;
            }
        }),
    }),
});

export const {
    useLazyGetSentCampaignLogsQuery,
    useLazyGetSentUniversityCourseLogsQuery,
    useLazyGetCourseAuditLogsQuery,
    useLazyGetSimAuditLogsQuery,
} = logsApi;
